import { createContext, useContext, useEffect, useState } from 'react';

// CONTEXT
import { AuthContext } from './AuthContext';

// SERVICES
import { getUserBDDInfo, updateUser } from 'services/userService';

const TILE_STYLES = ['classic'];
const DEFAULT_TILE_STYLE = 'classic';

const TileStyleContext = createContext();

export function TileStyleProvider({ children }) {
  const [tileStyle, setTileStyle] = useState(DEFAULT_TILE_STYLE);
  const { email } = useContext(AuthContext);
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!email) return;
    const fetchUser = async () => {
      const user = await getUserBDDInfo();
      setUser(user.data[0]);
    };
    fetchUser();
  }, [email]);

  useEffect(() => {
    if (user) {
      const stored = user.USR_TILE_STYLE;
      const next = TILE_STYLES.includes(stored) ? stored : DEFAULT_TILE_STYLE;
      setTileStyle(next);
      document.documentElement.setAttribute('data-tile-style', next);
    }
  }, [user]);

  const changeTileStyle = (newStyle) => {
    if (!TILE_STYLES.includes(newStyle)) return;
    setTileStyle(newStyle);
    document.documentElement.setAttribute('data-tile-style', newStyle);
    if (email) {
      updateUser({ tile_style: newStyle });
    }
  };

  return (
    <TileStyleContext.Provider value={{ tileStyle, changeTileStyle }}>
      {children}
    </TileStyleContext.Provider>
  );
}

export function useTileStyle() {
  return useContext(TileStyleContext);
}
